import { gql } from '@apollo/client'

export const CreateProjectHeaderAndFooterMutation = gql`
    mutation createProjectHeaderAndFooter(
        $createProjectHeaderAndFooterInput: CreateProjectHeaderAndFooterInput!
    ) {
        createProjectHeaderAndFooter(
            input: $createProjectHeaderAndFooterInput
        ) {
            name
            isActive
            headerAndFooters {
                fontSettings {
                    fontFamily
                    fontSize
                    fontStyles
                    fontColor
                }
                justification
                headerFromTop
                footerFromBottom
                mergeFields {
                    fieldName
                    actualValue
                }
            }
            isEnablePreview
            headerMergeFieldContent {
                mergeFieldFormat
                columnNumber
                justification
            }
            footerMergeFieldContent {
                mergeFieldFormat
                columnNumber
                justification
            }
            footerCopyright {
                mergeFieldFormat
                columnNumber
                justification
            }
            firmId
            projectId
        }
    }
`

export const SetProjectHeaderAndFooterAsActiveMutation = gql`
    mutation setProjectHeaderAndFooterAsActive(
        $setActiveProjectHeaderAndFooterInput: SetActiveProjectHeaderAndFooterInput!
    ) {
        setProjectHeaderAndFooterAsActive(
            input: $setActiveProjectHeaderAndFooterInput
        ) {
            projectId
            id
        }
    }
`

export const DeleteProjectHeaderAndFooterMutation = gql`
    mutation deleteProjectHeaderAndFooter(
        $deleteProjectHeaderAndFooterInput: DeleteProjectHeaderAndFooterInput!
    ) {
        deleteProjectHeaderAndFooter(input: $deleteProjectHeaderAndFooterInput)
    }
`

export const CopyProjectHeaderAndFooterMutation = gql`
    mutation copyProjectHeaderAndFooter(
        $copyProjectHeaderAndFooterInput: CopyProjectHeaderAndFooterInput!
    ) {
        copyProjectHeaderAndFooter(input: $copyProjectHeaderAndFooterInput) {
            projectId
            id
            name
        }
    }
`

export const UpdateProjectHeaderAndFooterMutation = gql`
    mutation updateProjectHeaderAndFooter(
        $updateProjectHeaderAndFooterInput: UpdateProjectHeaderAndFooterInput!
    ) {
        updateProjectHeaderAndFooter(
            input: $updateProjectHeaderAndFooterInput
        ) {
            name
            isActive
            id
            headerAndFooters {
                fontSettings {
                    fontFamily
                    fontSize
                    fontStyles
                    fontColor
                }
                justification
                headerFromTop
                footerFromBottom
                mergeFields {
                    fieldName
                    actualValue
                }
                borderSettings{
                    headerFooterSection
                    headerFooterBorderType
                    borderColor
                    lineWeight
                }
            }
            isEnablePreview
            headerMergeFieldContent {
                mergeFieldFormat
                columnNumber
                justification
            }
            footerMergeFieldContent {
                mergeFieldFormat
                columnNumber
                justification
            }
            footerCopyright {
                mergeFieldFormat
                columnNumber
                justification
            }
            firmId
            projectId
            isTemplateLocked
        }
    }
`

export const ToggleMergeFieldMutation = gql`
    mutation toggleMergeFieldPreview(
        $toggleMergeFieldPreviewInput: ToggleMergeFieldPreviewInput!
    ) {
        toggleMergeFieldPreview(input: $toggleMergeFieldPreviewInput) {
            name
            isActive
            id
            headerAndFooters {
                fontSettings {
                    fontFamily
                    fontSize
                    fontStyles
                    fontColor
                }
                justification
                headerFromTop
                footerFromBottom
                mergeFields {
                    fieldName
                    actualValue
                }
            }
            isEnablePreview
            headerMergeFieldContent {
                mergeFieldFormat
                columnNumber
                justification
            }
            footerMergeFieldContent {
                mergeFieldFormat
                columnNumber
                justification
            }
            firmId
            projectId
        }
    }
`

export const TransferProjectHeaderAndFooterImageMutation = gql`
    mutation transferProjectHeaderFooterImage(
        $transferProjectHeaderAndFooterImageInput: TransferProjectHeaderAndFooterImageInput!
    ) {
        transferProjectHeaderFooterImage(input: $transferProjectHeaderAndFooterImageInput) {
            imageUrl
            __typename
        }
    }
`